import React from 'react';
import classNames from 'classnames/bind';
import styles from './index.pcss';
import properties from '../../../../../modules/ajio-util/properties';

const imageBaseUrl: string = properties.getProperty('imageBaseUrl');
const cx = classNames.bind(styles);

const PartnerList = (props): JSX.Element => {
  const { deviceType = 'mobile', partnerArr = [] } = props;
  return (
    <div className={cx(deviceType === 'desktop' ? 'desktop-container' : 'container')}>
      {partnerArr.map(eachPartner => {
        return (
          <div className={cx(deviceType === 'desktop' ? 'desktop-eachPartner' : 'eachPartner')}>
            <img src={`${imageBaseUrl}${eachPartner}`} />
          </div>
        );
      })}
    </div>
  );
};

export default PartnerList;
